import { Box } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { Placeholder } from '#modules/user/features/dashboard';
import { UfoIcon } from '#features/ui';

export const ErrorNotFound = () => {
  const { t } = useLingui();

  return (
    <Box w="100%">
      <Placeholder icon={<UfoIcon style={{ fontSize: '60px' }} />}>
        <Placeholder.Title>{t`pageNotFound`}</Placeholder.Title>
        <Placeholder.Button asChild>
          <a href="/">{t`goHome`}</a>
        </Placeholder.Button>
      </Placeholder>
    </Box>
  );
};
